<template>
  <div class="persion">
    <van-nav-bar
      class="barColor"
      :title="$t('姓名')"
      :right-text="$t('提交')"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="persion-card">
      <div class="name">{{ $t('请输入姓名') }}</div>
    </div>
    <div class="persion-card">
      <van-field
        v-model="name"
        :placeholder="$t('请输入您的姓名')"
        class="nameText"
      />
    </div>
  </div>
</template>
<script>
import { Field, NavBar, Dialog, Icon, Divider, Toast } from 'vant'
import Vue from 'vue'
import { postUserInfo, queryStaffToekn } from '@/services/api'

Vue.use(Icon)
Vue.use(Field)
Vue.use(Divider)
Vue.use(NavBar)
Vue.use(Toast)

export default {
  name: 'PersionalName',
  components: {
    NavBar,
  },
  data() {
    return {
      name: '',
      user: {},
      roleId: '',
      companyId: '',
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async onClickRight() {
      if (!this.name) {
        Dialog.alert({
          title: this.$t('提示'),
          message: this.$t('姓名不能为空!'),
        })
        return
      }
      await this.postUserInfo()
      this.$router.push({
        path: '/persionInfo',
        params: { name: this.name },
        query: { refresh: true },
      })
    },
    async postUserInfo() {
      this.user = JSON.parse(localStorage.getItem('user'))
      let newUser = await queryStaffToekn({ token: this.user.token })
      this.roleId = newUser.roleList.map((item) => item.id).join(',')
      this.user.name = this.name // 更新 user 对象中的 name 属性

      await postUserInfo({
        id: this.user.id,
        name: this.name,
        companyId: this.user.companyId,
        roleId: this.roleId,
        facePhoto: newUser.facePhoto || '',
      })
      localStorage.setItem('user', JSON.stringify(this.user)) // 存储更新后的user对象
      this.$router.push({
        params: { name: this.name }, // 将更新后的姓名作为参数传递给下面的页面
      })
      Toast(this.$t('修改成功'))
    },
  },
}
</script>
<style lang="less" scoped>
.van-nav-bar {
  background: #00bdff;
}
.persion /deep/ .van-nav-bar__title {
  color: white !important;
  font-size: 16px;
}
.persion /deep/ .van-nav-bar .van-icon {
  color: white !important;
}

.persion /deep/ .van-nav-bar__text {
  color: white !important;
}

.persion {
  height: 100%;

  .persion-card {
    height: 56px;
    padding: 0px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fefffe;
    font-size: 16px;
    line-height: 24px;
    border-bottom: 1px solid #ebebeb;

    .name {
      font-weight: bold;
    }
  }
}
</style>
